import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SummaryCardData } from '../../../models';

@Component({
  selector: 'app-summary-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './summary-card.component.html',
  styleUrl: './summary-card.component.scss'
})
export class SummaryCardComponent {
  @Input() data!: SummaryCardData;
  @Input() loading: boolean = false;
}
